export default __webpack_public_path__ + "static/media/imgRecomp2.fa6b925a.png";